/*
 * Decléor — Gold heading flourish
 * ---------------------------------------------------------------------------
 * Draws the gold underline under .kicker-flourished elements as they scroll
 * into view. Adds `flourish-ready` to <html> so the hidden-initial (scaleX 0)
 * state only applies when JS can actually animate it — if this script or
 * IntersectionObserver is unavailable, the line simply shows (no draw).
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    return;
  }

  document.documentElement.classList.add('flourish-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-inview');
          observer.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.kicker-flourished');
    for (var i = 0; i < els.length; i++) {
      observer.observe(els[i]);
    }
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan content added by the theme editor (Shopify's native event fires on DOCUMENT and
  // carries the reloaded section as event.target) and by dynamic section renders (the theme's
  // own event is dispatched on WINDOW, non-bubbling, with only the id in detail). The original
  // `document` listener for `theme:section:load` never fired (that event is window-only), so a
  // section edited in the theme editor kept its gold underline hidden until a full reload.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event && event.target ? event.target : document);
  });
  window.addEventListener('theme:section:update', function (event) {
    var id = event && event.detail ? event.detail.sectionId : null;
    var scope = id ? document.getElementById('shopify-section-' + id) : null;
    observe(scope || document);
  });
})();
